import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Preloader from '../preloader/Preloader'
import { CFormSelect } from '@coreui/react'

//services
import { getOrderTypeSingle, createOrderTypes, updateOrderTypes } from 'src/services'

//components
import { BreadCrumb, Card } from 'src/components'

const CreateOrUpdate = () => {
  const history = useHistory()
  const { id } = useParams()
  const isUpdating = id !== undefined
  const [loading, setLoading] = useState(isUpdating)
  const [orderTypeList, setOrderTypeList] = useState({
    name: '',
    has_spread_charge_rate: '',
    error_list: [],
  })

  useEffect(() => {
    if (isUpdating) {
      getOrderTypeSingle(id)
        .then((res) => {
          if (res.data.status === 200) {
            setOrderTypeList(res.data.order_types)
          } else {
            history.push('/order_types')
          }
          setLoading(false)
        })
        .catch(() => {
          history.push('/order_types')
          setLoading(false)
        })
    }
  }, [id, history, isUpdating])

  const handleInput = (e) => {
    e.persist()
    setOrderTypeList({ ...orderTypeList, [e.target.name]: e.target.value })
  }

  const submitForm = (e) => {
    e.preventDefault()
    const data = orderTypeList

    const submitAction = isUpdating
      ? () => updateOrderTypes(id, data)
      : () => createOrderTypes(data)

    submitAction()
      .then((res) => {
        if (res.data.status === 200) {
          swal('Success', res.data.message, 'success')
          history.push('/order_types')
        } else if (res.data.status === 400 || res.data.status === 422) {
          setOrderTypeList({ ...orderTypeList, error_list: res.data.errors || {} })
        }
      })
      .catch((error) => {
        swal('Error', 'An error occurred', 'error')
      })
  }

  if (loading) {
    return <Preloader />
  }

  const title = 'Order Types'
  const isanupdate = isUpdating ? 'Update' : 'Add'

  const breadcrumb = [
    {
      title: title,
      name: 'Add' + title,
      subtitle: isanupdate,
      subtitleroute: '/order_types',
    },
  ]

  const cardValues = [
    {
      title: 'Order' + title,
      addorupdate: isanupdate,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />

      <div className="content">
        <div className="card card-primary">
          <Card data={cardValues}>
            <form onSubmit={submitForm}>
              <div className="row">
                {/* First Name */}
                <div className="col-6">
                  <div className="form-group">
                    <label className="pb-2">
                      Name <span className="text-danger">*</span>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      onChange={handleInput}
                      value={orderTypeList.name}
                      placeholder="Name"
                    />
                    <span className="text-danger">{orderTypeList?.error_list?.name}</span>
                  </div>
                </div>
                {/* has_spread_charge_rate */}
                <div className="col-6">
                  <div className="form-group">
                    <label className="pb-2">
                      Has spread charge rate<span className="text-danger">*</span>
                    </label>
                    <CFormSelect
                      onChange={(e) => handleInput(e)}
                      aria-label="Default select example"
                      name="has_spread_charge_rate"
                      value={orderTypeList.has_spread_charge_rate}
                    >
                      <option>-- Please select --</option>
                      <option value="0">No</option>
                      <option value="1">Yes</option>
                    </CFormSelect>{' '}
                    <span className="text-danger">
                      {orderTypeList?.error_list?.has_spread_charge_rate}
                    </span>
                  </div>
                </div>
              </div>
              <button type="submit" className="btn btn-primary mt-3">
                {isUpdating ? 'Update' : 'Save'}
              </button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default CreateOrUpdate
